var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.285,
    height: 27.285,
    viewBox: "0 0 27.285 27.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-calendar-5718843",
    transform: "translate(-29.989 -30.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12174",
    "data-name": "Path 12174",
    d: "M55.735,33.64A5.252,5.252,0,0,0,52.026,32.1H50.977V31.052a1.049,1.049,0,1,0-2.1,0V32.1h-4.2V31.052a1.049,1.049,0,1,0-2.1,0V32.1h-4.2V31.052a1.049,1.049,0,1,0-2.1,0V32.1H35.236a5.253,5.253,0,0,0-5.247,5.247V52.041a5.254,5.254,0,0,0,5.247,5.247H52.026a5.254,5.254,0,0,0,5.247-5.247V37.349a5.253,5.253,0,0,0-1.539-3.708Zm-.56,18.4a3.148,3.148,0,0,1-3.148,3.148H35.236a3.148,3.148,0,0,1-3.148-3.148V40.5H55.175Zm0-13.642H32.088V37.349A3.148,3.148,0,0,1,35.236,34.2h1.049V35.25a1.049,1.049,0,1,0,2.1,0V34.2h4.2V35.25a1.049,1.049,0,1,0,2.1,0V34.2h4.2V35.25a1.049,1.049,0,1,0,2.1,0V34.2h1.049a3.148,3.148,0,0,1,3.148,3.148Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12175",
    "data-name": "Path 12175",
    d: "M537.378,579.654a1.574,1.574,0,1,1-1.574-1.574,1.574,1.574,0,0,1,1.574,1.574",
    transform: "translate(-492.173 -534.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12176",
    "data-name": "Path 12176",
    d: "M800.458,579.654a1.574,1.574,0,1,1-1.574-1.574,1.574,1.574,0,0,1,1.574,1.574",
    transform: "translate(-748.956 -534.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12177",
    "data-name": "Path 12177",
    d: "M274.3,579.654a1.574,1.574,0,1,1-1.574-1.574,1.574,1.574,0,0,1,1.574,1.574",
    transform: "translate(-235.389 -534.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12178",
    "data-name": "Path 12178",
    d: "M537.378,798.884a1.574,1.574,0,1,1-1.574-1.574,1.574,1.574,0,0,1,1.574,1.574",
    transform: "translate(-492.173 -748.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12179",
    "data-name": "Path 12179",
    d: "M800.458,798.884a1.574,1.574,0,1,1-1.574-1.574,1.574,1.574,0,0,1,1.574,1.574",
    transform: "translate(-748.956 -748.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12180",
    "data-name": "Path 12180",
    d: "M274.3,798.884a1.574,1.574,0,1,1-1.574-1.574,1.574,1.574,0,0,1,1.574,1.574",
    transform: "translate(-235.389 -748.942)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5edada841d8519113704a528909a6b26.svg";
export { ForwardRef as ReactComponent };